import { useQuery } from '@tanstack/react-query'
import { viewerApi } from '../api/viewer-api'
import { syncViewerLanguage } from './sync-language'
import { useViewerStore } from './viewer-store'

export const viewerKeys = {
  all: ['viewer'] as const,
  me: () => [...viewerKeys.all, 'me'] as const,
}

/**
 * Профиль из `/app/me`. Кладётся в стор прямо в `queryFn`, до того как запрос
 * станет успешным: экраны читают профиль из стора и не должны увидеть
 * `null` при уже загруженных данных.
 *
 * Успешный ответ заодно снимает отказ подписи и блокировку: раз `/app/me`
 * прошёл, бэкенд снова пускает этого человека (исправили токен бота,
 * поддержка сняла блокировку).
 * При возврате в приложение профиль перечитывается — так протухшая за сутки
 * подпись обнаруживается сразу, а не на первом действии.
 */
export const useViewerQuery = () =>
  useQuery({
    queryKey: viewerKeys.me(),
    queryFn: async ({ signal }) => {
      const viewer = await viewerApi.getMe(signal)
      const store = useViewerStore.getState()

      store.setViewer(viewer)
      store.clearAuthError()
      syncViewerLanguage(viewer)

      return viewer
    },
  })
